export default __webpack_public_path__ + "static/media/Home Page copy-07.bd8fce1c.jpg";